import { useGetAllOperatorPrograms } from './useGetAllOperatorPrograms'
import { useGetList } from './useGetList'
import { useGetOntologyErrors } from './useGetOntologyErrors'
import { useGetOntologyErrorsByProgramInstance } from './useGetOntologyErrorsByProgramInstance'
import { useGetOperatorProgramInstances } from './useGetOperatorProgramInstances'
export {
  getOperatorProgramInstancesDiscoveryIdentity,
  getOperatorProgramInstancesQueryKey,
} from './useGetOperatorProgramInstances'
export type {
  GetOperatorProgramInstancesRequest,
  OperatorProgramInstance,
} from './useGetOperatorProgramInstances'
import { useGetPlanOverview } from './useGetPlanOverview'
import { useGetActiveOperatorProfiles, useGetProfile } from './useGetProfile'
import { useGetProgramErrors } from './useGetProgramErrors'
import {
  useGetProgramInstanceErrors,
  useGetProgramInstanceErrorsForPrograms,
} from './useGetProgramInstanceErrors'
import {
  useGetProgramInstancePerformance,
  useGetProgramInstancePerformances,
} from './useGetProgramInstancePerformance'
import { useGetProgramInstanceStats } from './useGetProgramInstanceStats'
import { useGetProgramList } from './useGetProgramList'
import { useGetProgramStats } from './useGetProgramStats'
import { useGetUnassignedTraining } from './useGetUnassignedTraining'
import { useMineSession } from './useMineSession'
import { useUpdateWorkforceProfile } from './useUpdateWorkforceProfile'

export type {
  GetProgramInstanceStatsResponse,
  OperatorProgramInstanceStats,
  ProgramInstanceStatsBreakdown,
} from './useGetProgramInstanceStats'

export const operator = {
  getList: useGetList,
  getProfile: useGetProfile,
  mineSession: useMineSession,
  getActiveList: useGetActiveOperatorProfiles,
  getAllPrograms: useGetAllOperatorPrograms,
  getProgramInstances: useGetOperatorProgramInstances,
  getProgramStats: useGetProgramStats,
  getProgramInstanceStats: useGetProgramInstanceStats,
  getProgramErrors: useGetProgramErrors,
  getProgramInstanceErrors: useGetProgramInstanceErrors,
  getProgramInstanceErrorsForPrograms: useGetProgramInstanceErrorsForPrograms,
  getProgramInstancePerformance: useGetProgramInstancePerformance,
  getProgramInstancePerformances: useGetProgramInstancePerformances,
  getPlanOverview: useGetPlanOverview,
  getUnassignedTraining: useGetUnassignedTraining,
  getProgramList: useGetProgramList,
  getOntologyErrors: useGetOntologyErrors,
  getOntologyErrorsByProgramInstance: useGetOntologyErrorsByProgramInstance,
  updateWorkforceProfile: useUpdateWorkforceProfile,
}
